<template src="./app-footer.html"> </template>

<script>
export default {
  name: "app-footer"
};
</script>

<style src="./app-footer.css" scoped></style>
